import { render, staticRenderFns } from "./FlapViewer.vue?vue&type=template&id=130578ca&scoped=true"
import script from "./FlapViewer.vue?vue&type=script&lang=js"
export * from "./FlapViewer.vue?vue&type=script&lang=js"
import style0 from "./FlapViewer.vue?vue&type=style&index=0&id=130578ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@5.97.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130578ca",
  null
  
)

export default component.exports